var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageUpload = function SvgImageUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#image-upload_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 156,
    height: 156,
    rx: 78,
    fill: "#E7EBF3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.791 78.673a3.304 3.304 0 0 0 3.294-3.294 3.304 3.304 0 0 0-3.294-3.294 3.304 3.304 0 0 0-3.294 3.294 3.304 3.304 0 0 0 3.294 3.294Zm9.882-16.47H64.555a3.304 3.304 0 0 0-3.294 3.293v32.941a3.304 3.304 0 0 0 3.294 3.295h46.118a3.304 3.304 0 0 0 3.294-3.295v-32.94a3.304 3.304 0 0 0-3.294-3.295Zm-3.294 29.646-16.47-9.882-3.295 6.588-9.882-13.176-9.882 16.47V68.79h39.529v23.06Z",
    fill: "#355B98"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "image-upload_svg__a",
    x: 0,
    y: 0,
    width: 172,
    height: 172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.25098 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1609_99560"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1609_99560",
    result: "shape"
  })))));
};
export default SvgImageUpload;